import { setLabels } from "../helpers/enum-helpers";

export enum CalendarDefinition {
    Propak = 1,
    Chep = 2,
    Walmart = 3
}

setLabels(CalendarDefinition, [
    [ CalendarDefinition.Propak, 'Propak' ],
    [ CalendarDefinition.Chep, 'CHEP' ],
    [ CalendarDefinition.Walmart, 'Walmart' ]
]);

export class CalendarDefinitionDetail {
    calendarDefinition: CalendarDefinition;
    description: string;
    monthNames: string[];
}

